import { StackedBarchartModule } from '../../../tmc-yard/widgets/reporting/stacked-bar-chart/stackedbarchart.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';
import { ExportVisitorLogWidgetComponent } from './components/export-visitor-log-widget.component';
import { ExportVisitorLogModule } from 'src/tmc-visit/components/reporting/export-visitor-log/export-visitor-log.module';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    StackedBarchartModule,
    CommonTranslationModule,
    CommonLayoutModule,
    ExportVisitorLogModule
  ],
  declarations: [
    ExportVisitorLogWidgetComponent
  ],
  exports: [
    ExportVisitorLogWidgetComponent
  ]
})
export class ExportVisitorLogWidgetModule { }
